import { render, staticRenderFns } from "./select-tree.vue?vue&type=template&id=2a749cae&"
import script from "./select-tree.vue?vue&type=script&lang=ts&"
export * from "./select-tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports